/* eslint-disable react/jsx-props-no-spreading */
import React, { ChangeEvent, SelectHTMLAttributes } from 'react'
import { useController } from 'react-hook-form'
import * as S from './FieldDropdownV2.styles'

interface Options {
  value: number | string,
  label: number | string
}

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  labelText: string,
  name: string,
  control: any,
  options: Options[]
  defaultValue?: string | number
  className?: string
}

const processError = (error: any) => {
  if (error.type === 'typeError') {
    return { ...error, message: 'Caractere inesperado e inválido!' }
  }
  return error
}

export default React.forwardRef<HTMLSelectElement, Props>(({
  labelText,
  name,
  control,
  options,
  defaultValue,
  className,
  onChange: selectOnChange,
  ...restProps
// eslint-disable-next-line @typescript-eslint/no-unused-vars
}: Props, ref) => {
  const {
    field: {
      value, onChange, onBlur, ref: fieldRef,
    },
    fieldState: { error },
  } = useController({ name, control })

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>) => {
    selectOnChange?.(event)
    onChange(event)
  }

  return (
    <S.Wrapper className={className}>
      <S.Label htmlFor={name}>{labelText}</S.Label>
      <S.Select
        id={name}
        defaultValue={defaultValue}
        value={value}
        error={error}
        onChange={handleOnChange}
        onBlur={onBlur}
        ref={fieldRef}
        {...restProps}
      >
        <S.Option disabled hidden value=''>
          Selecione
        </S.Option>
        {options.map((option) => (
          <S.Option
            key={option.value}
            value={option.value}
          >
            {option.label}
          </S.Option>
        ))}
      </S.Select>
      {error && <S.Error>{processError(error).message}</S.Error>}
    </S.Wrapper>
  )
})
